<nz-list [nzItemLayout]="'horizontal'">
    <div *ngFor="let user of data">
        <nz-list-item>
            <nz-list-item-meta [nzTitle]="user.role" [nzAvatar]="user.photo_url" [nzDescription]="user.first_name">
                <!-- <ng-template #nzTitle>
            <a href="https://ng.ant.design">{{ item.title }}</a>
          </ng-template> -->
            </nz-list-item-meta>
        </nz-list-item>
    </div>
</nz-list>